module.exports = __webpack_public_path__ + "static/media/irrigation1.a392acfc.jpg";